module.exports = __webpack_public_path__ + "static/media/locofast-blue.99c62406.png";